import {gql} from 'graphql-tag';

export const GET_STORE_LOCATOR_ITEMS_BY_SETTINGS = gql`
  query getStoreLocatorItemsBySettingsId($settingsId: ID!) {
    getStoreLocatorItemsBySettingsId(settingsId: $settingsId) {
      id
      settingsId
      clientId
      name
      address
      address2
      city
      state
      postalcode
      country
      phone
      tollfreephone
      fax
      websiteNectar
      websiteDC
      monopen
      monclose
      tueopen
      tueclose
      wedopen
      wedclose
      thuopen
      thuclose
      friopen
      friclose
      satopen
      satclose
      sunopen
      sunclose
      nectarBrand
      dreamCloud_Brand
      awaraBrand
      levelSleepBrand
      residentBrand
      sienaBrand
      nectarOriginal
      nectarLush
      nectarClassic
      nectarPremier
      nectarPremierCopper
      nectarClassicHybrid
      nectarPremierHybrid
      nectarPremierCopperHybrid
      nectarultra
      nectarultrahybrid
      adjustableBase
      theDreamCloud
      dreamCloudPremier
      dreamCloudPremierRest
      awara
      levelSleep
      siena
      sleepAccessories
      productCount_Nectar
      productCount_DC
      preferred_retailer
      best_selection
      ranking
      icon
      no1NectarRetailer
      mapIcon
      offerType
      shortSaleBanner
      saleBannerInStoreDetails
      topSeller
      pickupToday
      storeAppontment
      onSale
      storeAppontmentURL
      archived
      createdAt
      updatedAt
    }
  }
`;